module.exports = __webpack_public_path__ + "img/aereoWhite.491dab0e.svg";